import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59f010ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "content" }

import AdvComp from "./components/AdvComp.vue";
import PageDetail from "../PageDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'aboutDetail',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AdvComp),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageDetail)
    ])
  ]))
}
}

})